export class AnonymousModel{
    anonymous:string;
    ishidden:boolean;

    constructor(){
        
    }
}


// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/nmodels/auth/anonymous.model.ts